import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0de2a2e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "billing-container" }
const _hoisted_2 = { class: "billing-name" }
const _hoisted_3 = { class: "billing-start-date" }
const _hoisted_4 = { class: "billing-end-date" }
const _hoisted_5 = { class: "billing-total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.billing.sensor.name), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.convertToLocalDateTime(_ctx.billing.createdAt)), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.convertToLocalDateTime(_ctx.billing.deletedAt)), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.hoursBetweenWithText(_ctx.sensorStartDate, _ctx.sensorEndDate)), 1)
  ]))
}